import type { IconProps } from '../icons';

import { Icon } from '../icons';

type AvatarCircleProps = {
  icon: IconProps;
  size?: 'xs' | 'md' | 'lg';
};

const sizeClasses = {
  xs: 'w-8 h-8',
  md: 'w-14 h-14',
  lg: 'w-16 h-16'
};

const AvatarCircle = ({ icon, size = 'md' }: AvatarCircleProps) => {
  const sizeClass = sizeClasses[size];

  return (
    <div
      className={`flex border-[0.5px] border-gray-300 items-center justify-center rounded-full bg-gray-100 text-gray-600 ${sizeClass}`}
    >
      <Icon {...icon} />
    </div>
  );
};

export { AvatarCircle };
export type { AvatarCircleProps };
